/**
 * APM 性能监控模块
 * 负责初始化火山引擎 APM Plus 监控
 */

import browserClient from '@apmplus/web'
import { match } from 'path-to-regexp'
import { isDevelopment, getHashPath } from '@/utils'
import router from '@/router'

// 构建路由匹配器
const routeMatchers = router
  .getRoutes()
  .filter(r => !r.redirect && !r.path.includes(':pathMatch'))
  .map(r => ({
    path: r.path,
    name: r.name,
    matcher: match(r.path, { decode: decodeURIComponent }),
  }))

/**
 * 初始化 APM 监控
 */
export function initApm() {
  // 初始化 APM
  browserClient('init', {
    aid: 1000236,
    token: 'a567eee081a94f1baff3257a92fb4f49',
    domain: 'https://apmplus.ap-southeast-1.volces.com',
    env: import.meta.env.MODE,
    plugins: {
      pageview: {
        routerMode: 'hash',
        extractPid: (url) => {
          const pathname = getHashPath(url)

          for (const r of routeMatchers) {
            if (r.matcher(pathname)) {
              return r.path
            }
          }

          // 没匹配到,统一归为 404
          return '/:pathMatch(.*)'
        }
      },
      blankScreen: {
        rootSelector: '#app',
      },
    },
  })

  // 在非开发环境下启动 APM
  if (!isDevelopment) {
    browserClient('start')
  }
}

/**
 * 设置 APM 用户 ID
 * @param {string} userId - 用户 ID
 */
export function setApmUserId(userId) {
  if (userId) {
    browserClient('context.set', 'userId', userId)
  }
}

/**
 * 清除 APM 用户 ID（用户登出时调用）
 */
export function clearApmUserId() {
  browserClient('context.delete', 'userId')
}
